import { Card, CardHeader } from "@/app/pwa/components/Card";;
import { Match } from "@/app/pwa/components/match/Match";
import { Match as IMatch } from "@/sources/kicker-amateur/types";
import { formatDateStyleFull, getKickoffDetails } from "@/utils/datetimeUtils";
import React from "react";


interface ClubTeamScheduleMatchProps {
  match: IMatch;
  teamId: number;
}

//TODO: unify
export function ClubTeamScheduleMatch({
  match,
  teamId,
}: ClubTeamScheduleMatchProps) {
  const { kickoffDateString } = getKickoffDetails(match);

  return (
    <Card p={false} className="my-2 border-b border-gray-150" id={match.Id?.toString()}>
      <CardHeader className="text-center border-none">
        <h4 className="font-semibold text-lg">
          {formatDateStyleFull(kickoffDateString)}
        </h4>
        <h5 className="font-normal text-gray-200 font-condensed text-base uppercase">
          {match.Contest?.Name}
          {match.Round && (
            <>
              , <span className="@sm/card:hidden">{match.Round.ShortName}</span>
              <span className="hidden @sm/card:inline">{match.Round.Name}</span>
            </>
          )}
        </h5>
      </CardHeader>

      <Match className="py-2 mb-2" match={match} teamId={teamId} showBigIcons widget={true} />
    </Card>
  );
}
